/**
 * Знак INGDG.
 *
 * Разомкнутая скобка со шевроном внутри: задача входит в систему,
 * результат выходит наружу.
 *
 * Цвет наследуется через currentColor, поэтому знак работает
 * в обеих темах без дублирования файла.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 96 96"
      fill="none"
      className={className}
      role="img"
      aria-label="INGDG"
      focusable="false"
    >
      <path
        d="M 62 20 A 34 34 0 1 0 62 76"
        stroke="currentColor"
        strokeWidth="11"
        strokeLinecap="round"
      />
      <path
        d="M 44 34 L 60 48 L 44 62"
        stroke="currentColor"
        strokeWidth="11"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
